import { BuildPresentationProps } from '../utils/build-presentation';
import { Slide } from '@features/powerpoint';
import { salesAttributionTitleSlide } from '@features/lci-report/slides/sales-attribution/sales-attribution-title-slide';
import { salesLiftSummaryChartSlide } from '@features/lci-report/slides/sales-attribution/sales-lift-summary-chart-slide';
import { salesLiftSummaryTableSlide } from '@features/lci-report/slides/sales-attribution/sales-lift-summary-table-slide';
import { rslContributionMetricsSummarySlide } from './rsl-contribution-metrics-summary-slide';
import { rslDimensionsTableSlide } from './rsl-dimensions-table-slide';

export const salesAttributionSlides = (
  props: BuildPresentationProps,
  slideMaster: string
): Slide[] => {
  const slides: Slide[] = [];

  if (props.customFields.includedSlides.salesAttribution.titleSlide) {
    slides.push(salesAttributionTitleSlide);
  }

  if (
    props.customFields.includedSlides.salesAttribution.summary &&
    props.salesSummary
  ) {
    slides.push(
      salesLiftSummaryChartSlide({
        slideMaster,
        overallSalesMetrics: props.salesSummary,
        iroas: props.calculatedFields.incrementalReturnOnAdSpend ?? 0,
      })
    );
  }

  if (
    props.customFields.includedSlides.salesAttribution.summaryTable &&
    props.salesSummary
  ) {
    slides.push(
      salesLiftSummaryTableSlide({
        slideMaster,
        overallSalesMetrics: props.salesSummary,
        keyTakeaways: props.customFields.rsaSummaryTable,
        rsaOverallResults: props.customFields.rsaOverallResults,
        excludedRows: ['controlSalesRate'],
      })
    );
  }

  if (
    props.customFields.includedSlides.salesAttribution.contributionMetrics &&
    props.salesSummary
  ) {
    slides.push(
      rslContributionMetricsSummarySlide({
        slideMaster,
        overallSalesMetrics: props.salesSummary,
        metric: 'total',
        title: 'Combined',
        keyTakeaways: props.customFields.cmOverall,
      }),
      rslContributionMetricsSummarySlide({
        slideMaster,
        overallSalesMetrics: props.salesSummary,
        metric: 'inStore',
        title: 'In-Store',
        keyTakeaways: props.customFields.cmInStore,
      }),
      rslContributionMetricsSummarySlide({
        slideMaster,
        overallSalesMetrics: props.salesSummary,
        metric: 'online',
        title: 'Online',
        keyTakeaways: props.customFields.cmOnline,
      })
    );
  }

  if (props.customFields.includedSlides.salesAttribution.dimensions) {
    const topDimensions = props.dimensionTableData.Top ?? [];
    const bottomDimensions = props.dimensionTableData.Bottom ?? [];

    const topPerformerSlideHeader =
      props.customFields.dimensions.Top.salesTableHeader.length > 0
        ? props.customFields.dimensions.Top.salesTableHeader
        : 'Top Performing Dimensions (Sales)';

    const bottomPerformerSlideHeader =
      props.customFields.dimensions.Bottom.salesTableHeader.length > 0
        ? props.customFields.dimensions.Bottom.salesTableHeader
        : 'Bottom Performing Dimensions (Sales)';

    if (topDimensions.length > 0 && props.salesSummary) {
      slides.push(
        rslDimensionsTableSlide({
          slideMaster,
          subdimensions: topDimensions,
          overallSalesMetrics: props.salesSummary,
          overallReport: props.report,
          slideHeader: topPerformerSlideHeader,
        })
      );
    }

    if (bottomDimensions.length > 0 && props.salesSummary) {
      slides.push(
        rslDimensionsTableSlide({
          slideMaster,
          subdimensions: bottomDimensions,
          overallSalesMetrics: props.salesSummary,
          overallReport: props.report,
          slideHeader: bottomPerformerSlideHeader,
        })
      );
    }
  }

  return slides;
};
